import Tool, { type ToolArgs } from '../../../tools/Tool';
import { wrapLink } from '../utils';
import { Editor } from 'slate';
import isUrl from 'is-url';

// Insert a hyperlink into the editor.
class ToolInsertLink extends Tool {
  static toolName = 'Link';
  static iconClass = 'fa-regular fa-link-horizontal';
  static shortcut = 'Cmd+k';
  static withoutRefocus = true; // So that when a link is first created focus stays in the link editor.

  static action({ editor }: ToolArgs): void {
    if (!editor?.selection) return;

    const selectedText = Editor.string(editor, editor.selection);
    const url = isUrl(selectedText) ? selectedText : '';

    wrapLink(editor, url, 'Link');
    // Keep the cursor inside the link so the toolbar appears. The user will
    // need to click back into the editor to continue editing anyway.
  }
}

export default ToolInsertLink;
